/** 时间与倒计时显示:所有倒计时以服务器时钟为准,页面只负责把秒数变成人话 */
const pad = (n: number) => String(n).padStart(2, '0');

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** 「2026-10-01」:只要日期的地方(到期日、有效期) */
export function fmtDate(iso: string | null | undefined): string {
  return iso ? fmtDateTime(iso).slice(0, 10) : '—';
}
export function fmtTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fmtMonthDay(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}
/** mm:ss 或 h:mm:ss */
export function fmtHms(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  return h > 0 ? `${h}:${pad(m)}:${pad(r)}` : `${pad(m)}:${pad(r)}`;
}
/** 「约 6 天后」「约 2 小时后」「19 分钟后」「45 秒后」 */
export function fmtWait(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  if (s >= 86400 * 2) return `约 ${Math.round(s / 86400)} 天后`;
  if (s >= 3600 * 2) return `约 ${Math.round(s / 3600)} 小时后`;
  if (s >= 60) return `${Math.ceil(s / 60)} 分钟后`;
  return `${s} 秒后`;
}
export function fmtAgo(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s} 秒前`;
  return `${Math.floor(s / 60)} 分钟前`;
}
/** 「2026 年 9 月 30 日」:证书落款日期(入参 YYYY-MM-DD;与服务端证书 PDF 同一写法) */
export function fmtCnDate(ymd: string): string {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(ymd);
  return m ? `${m[1]} 年 ${Number(m[2])} 月 ${Number(m[3])} 日` : ymd;
}
/** 「10-25 14:00」:后台表格里的短日期时间 */
export function fmtShort(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** 消息时间(设计图 21):今天「10:32」· 昨天「昨天」· 今年「10-27」· 往年「2025-10-27」 */
export function fmtMsgTime(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  if (d.toDateString() === now.toDateString()) return fmtTime(iso);
  if (d.toDateString() === new Date(now.getTime() - 86400_000).toDateString()) return '昨天';
  const md = `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return d.getFullYear() === now.getFullYear() ? md : `${d.getFullYear()}-${md}`;
}
/** 「10-25 14:00–15:00」;跨天时结束带日期 */
export function fmtRange(start: string | null | undefined, end: string | null | undefined): string {
  if (!start || !end) return '—';
  const a = new Date(start);
  const b = new Date(end);
  const sameDay = a.toDateString() === b.toDateString();
  return `${fmtShort(start)}–${sameDay ? fmtTime(end) : fmtShort(end)}`;
}
/** ISO → <input type="datetime-local"> 的值(本地时区、分钟精度);空 / 非法给空串 */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
/** datetime-local 的值 → ISO;空给 undefined(接口里「不传」和「清空」是两回事,由调用方决定) */
export function fromLocalInput(v: string | null | undefined): string | undefined {
  if (!v) return undefined;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}
/** 本地时间加减分钟后给 datetime-local 的值 */
export function shiftLocalInput(v: string, minutes: number): string {
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  return toLocalInput(new Date(d.getTime() + minutes * 60_000).toISOString());
}
